import actions from "./actions";
export const toggleDrawer = name => async dispatch => dispatch(actions.toggleDrawer(name));
export const closeDrawer = () => async dispatch => dispatch(actions.toggleDrawer(null));
export const setFooterVisible = toggle => async dispatch => dispatch(actions.setFooterVisible(toggle));

/** @deprecated */
export const toggleSearch = () => async dispatch => dispatch(actions.toggleSearch());